import { Component, Vue } from 'vue-property-decorator';
import './Header.scss';
import { SettingStoreConst } from '@/common/store/setting.store';
import { namespace } from 'vuex-class';
import AppConstants from '@/common/constants/app.constants';
import { SortStoreConst } from '@/tsort/store/sort.store';
import LoadingComponent from '../components/loading/loading.component';
import { ScanSettingResponse } from '@/tsort/model/response/scan-setting-response.model';
import InductionService from '../service/induction.service';

const SettingStore = namespace(SettingStoreConst.SETTING_STORE_MODULE_NAME);
const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
const Auth = namespace('Auth');
@Component({})
export default class HeaderComponent extends Vue {
  inductionService = new InductionService();
  isLoading = false;

  @SettingStore.Getter
  deviceId!: string | number;

  @SettingStore.Getter
  inductionName!: string;

  @SettingStore.Getter
  inductionId!: string;

  @Auth.Getter
  private isLoggedIn!: boolean;

  @Auth.Action
  private logout!: () => void;

  @Auth.Getter
  userDetailNickName!: string;

  @Auth.Getter
  private userDetailAvatar!: string;

  @SortStore.Action
  updateWesNo!: (value: number) => void;

  @SortStore.Action
  updateLastChuteNo!: (value: string) => void;

  @SortStore.Action
  updateRejectedTask!: (value: boolean) => void;

  @SortStore.Getter
  scanSetting!: ScanSettingResponse;

  onClickLogout(): void {
    this.logout();
    this.$router.push(AppConstants.LOGIN_ROUTER_PATH);
    this.updateWesNo(0);
    this.updateLastChuteNo('');
    this.updateRejectedTask(false);
  }

  /**
   * 休憩画面に遷移します。
   */
  async onCloseInduction() {
    try {
      this.isLoading = true;
      await this.inductionService.changeInductionStatus(true, AppConstants.NAME_BREAK_INDUCTION_PAGE);
    } catch {
      return null;
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * インダクション処理モードを取得します。
   */
  get inductionProcessingMode() {
    return this.scanSetting?.inductionProcessingMode;
  }

  render() {
    return (
      <div v-frag>
        <LoadingComponent isActive={this.isLoading} />
        <div class="header">
          <div class="header-main">
            <div class="row w-100 no-gutters">
              <div
                class={[
                  'header-wapper',
                  {
                    'col-3': !this.inductionProcessingMode,
                    'break-induction-btn-container': this.inductionProcessingMode
                  }
                ]}
              >
                <div class="logo"></div>
                {this.inductionProcessingMode && (
                  <div class="break-induction-btn h-100 d-flex flex-row justify-content-start align-items-center">
                    <button
                      onClick={() => {
                        this.onCloseInduction();
                      }}
                    >
                      <span class="icon icon-break-induction-btn-svg"></span>
                      <span class="text-nowrap">休憩</span>
                    </button>
                  </div>
                )}
              </div>
              <div
                class={{
                  'd-flex flex-row justify-content-end align-items-center': true,
                  col: this.isShowTextInduction
                }}
              >
                {this.isShowTextInduction && (
                  <span class="text-white text-induction">
                    インダクション名: {!this.inductionName ? this.inductionId : this.inductionName}
                  </span>
                )}
              </div>
              <div
                class={{
                  'd-flex flex-row justify-content-end align-items-center ml-5': true,
                  col: !this.isShowTextInduction
                }}
              >
                <span class="text-white text-right align-middle">
                  機器ID: {this.deviceId ? this.deviceId : '未登録'}
                </span>
              </div>
              <div class="d-flex flex-row justify-content-end align-items-center ml-4 mr-0">
                {this.isLoggedIn && this.authMode && (
                  <b-dropdown right class="m-2" noCaret={true} ref="dropdown">
                    <template slot="button-content">
                      <span class="text-white d-flex pr-0 flex-row align-items-center text-right align-middle cursor-pointer position-relative">
                        <span class="align-user-info align-image">
                          {this.userDetailAvatar ? (
                            <img src={this.userDetailAvatar} width="20" height="20" class="rounded-circle" />
                          ) : (
                            <i class="material-icons align-middle material-icons-small">face</i>
                          )}
                          &nbsp; <span class="text-size-14">{this.userDetailNickName}</span> &nbsp;
                        </span>
                        <i class="material-icons align-middle material-icons-small cursor-pointer resize-arrow">
                          arrow_drop_down
                        </i>
                      </span>
                    </template>
                    <b-dropdown-item
                      ref="dropdown"
                      activeClass="mt-3"
                      class="align-index"
                      on-click={(_e: Event) => this.onClickLogout()}
                    >
                      ログアウト
                      <i class="material-icons material-icons-small align-icon-arrow">keyboard_arrow_right</i>
                    </b-dropdown-item>
                  </b-dropdown>
                )}
              </div>
            </div>
          </div>
          <div class="header-line"></div>
        </div>
      </div>
    );
  }
  get isShowTextInduction() {
    if (this.inductionId || this.inductionName) {
      return (
        this.$route.meta?.parentText1 && this.$route.meta?.parentText1 === AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT
      );
    }
  }

  get authMode() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return config && config['AUTH_MODE'];
  }
}
